export const buildProvenance = { "commitHash": "0e4843b87f0458549bc8a1da84341fa032109862", "branchName": "refs/heads/release/2025.4", "buildDate": "2026-01-14T23:43:30.443Z", "version": "2025.4.10338" };
